import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-17b1056a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paginator" }
const _hoisted_2 = {
  key: 0,
  class: "paginator__elm"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "paginator__elm-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconDoubleChevron = _resolveComponent("IconDoubleChevron")!
  const _component_IconChevron = _resolveComponent("IconChevron")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.totalPages > _ctx.FIRST_PAGE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (
					_ctx.totalPages > 2 &&
					_ctx.currentPage !== _ctx.FIRST_PAGE &&
					_ctx.currentPage > _ctx.SECOND_PAGE
				)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick(_ctx.FIRST_PAGE, _ctx.S_TO_FIRST_PAGE))),
                class: "paginator__elm-item"
              }, [
                _createVNode(_component_IconDoubleChevron)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentPage !== _ctx.FIRST_PAGE)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick(_ctx.ZERO, _ctx.S_DECREMENT_PAGE))),
                class: "paginator__elm-item paginator__elm_incdec"
              }, [
                _createVNode(_component_IconChevron)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.total, (page, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(
					_ctx.currentPage === page + _ctx.count
						? 'paginator__elm-item paginator__elm-item_green'
						: 'paginator__elm-item'
				),
              onClick: ($event: any) => (_ctx.onClick(page + _ctx.count, index)),
              key: index
            }, _toDisplayString(page + _ctx.count), 11, _hoisted_3))
          }), 128)),
          (_ctx.totalPages - 2 > _ctx.currentPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.totalPages > _ctx.NUMBER_OF_CELL)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " ... "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.totalPages > 3)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClick(_ctx.totalPages, _ctx.S_LAST_PAGE))),
                class: _normalizeClass(
					_ctx.currentPage === _ctx.totalPages
						? 'paginator__elm-item paginator__elm-item_green'
						: 'paginator__elm-item'
				)
              }, _toDisplayString(_ctx.totalPages), 3))
            : _createCommentVNode("", true),
          (_ctx.currentPage !== _ctx.totalPages)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "paginator__elm-item paginator__elm_incdec",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClick(_ctx.ZERO, _ctx.S_INCREMENT_PAGE)))
              }, [
                _createVNode(_component_IconChevron, { class: "paginator__elm-item-chevron_right" })
              ]))
            : _createCommentVNode("", true),
          (
					_ctx.currentPage !== _ctx.totalPages && _ctx.currentPage !== _ctx.totalPages - 1
				)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "paginator__elm-item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClick(_ctx.totalPages, _ctx.S_LAST_PAGE)))
              }, [
                _createVNode(_component_IconDoubleChevron, { class: "paginator__elm-item-chevron_right" })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}